import React, { Component } from 'react'

export default class Educ extends Component {
render() {
    return (
        <div className='eye1'>
            <div className="pull">
                <h1>QUALIFICATION</h1>
                <div className='fle'>
                    <div className='line'></div>
                </div>
                <div className='aboui'>
                    <div id="nam1">
                        <h2>Education:</h2>
                        <div className='fle1'>
                            <div className='line'></div>
                        </div>
                        <h2>
                            Bachelor Degree Of Science In Geology
                        </h2>
                        <p>
                            Delta State University, Abraka(2018-2021).
                        </p>
                        <h2>
                            Certified Science
                        </h2>
                        <p>
                            Chosen Star International College, Ibusa( All Results Available).
                        </p>
                        <h2>
                            First Leaving Certificate
                        </h2>
                        <p>
                            Mercy Nursary And Primary School, Ibusa(Certified).
                        </p>
                    </div>
                    <div id="nam1">
                        <h2>Experience:</h2>
                        <div className='fle1'>
                            <div className='line'></div>
                        </div>
                        <h2>
                            May 23 2022 To Recurrent
                        </h2>
                        <p>
                            Doing a internship at kuda Bank as a web-developer
                        </p>
                        <h2>
                            May 23 2022 To Recurrent
                        </h2>
                        <p>
                            Doing a internship at kuda Bank as a web-developer
                        </p>
                        <h2>
                            May 23 2022 To Recurrent
                        </h2>
                        <p>
                            Doing a internship at kuda Bank as a web-developer
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}
}
